import React from 'react';

import fetchContent from '../../helpers/backend-communication';
import { getCountryName } from '../../helpers/countryNames';
import CountryAssistanceOECDPanel from './CountryAssistanceOECDPanel';
import CountryAssistanceOECDTable from './CountryAssistanceOECDTable';

class CountryAssistanceOECD extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null
    };
  }

  componentDidMount() {
    this.fetchData(
      this.props.countryCode,
      this.props.onLoading
    );
  }

  fetchData(countryCode, onLoading) {
    const queryString = `?country=${countryCode}&projects=true`;

    onLoading(true);
    fetchContent('oecd', queryString)
      .then(responseObject => {
        this.setState({
          data: this.formatData(responseObject),
        });
        onLoading(false);
      })
      .catch(error => {
        console.error('Fetch went wrong', error);
        onLoading(false);
      });
  }

  formatData(data) {
    const formattedData = {
      provided: [],
      received: []
    };

    Object.keys(data).reverse().forEach(key => {
      const {
        total_projects_received,
        total_projects_provided,
        projects
      } = data[key];

      if (total_projects_received > 0) {
        formattedData.received = formattedData.received.concat(
          this.buildProjectList(projects.received, key)
        )
      }

      if (total_projects_provided > 0) {
        formattedData.provided = formattedData.provided.concat(
          this.buildProjectList(projects.provided, key)
        );
      }
    });

    return formattedData;
  }

  buildProjectList(projects, Year) {
    return projects.map(project => {
      return {
        Year,
        Donor: getCountryName(project.oecd_donor_country),
        Recipient: getCountryName(project.oecd_recipient_country),
        'Channel of delivery': project.channel_name,
        'Project title': project.project_title,
        'Long description': project.description
      };
    });
  }

  renderPanels() {
    const data = this.state.data,
      countryName = getCountryName(this.props.countryCode);

    return Object.keys(data).map(key => {
      const projects = data[key];

      if (projects.length === 0) return null;

      return (
        <CountryAssistanceOECDPanel
          header={ `International assistance ${key} by ${countryName}` }
          key={ key }
          id={ `oecd-${key}` }
        >
          <CountryAssistanceOECDTable
            type={ key }
            data={ projects }
          />
        </CountryAssistanceOECDPanel>
      );
    });
  }

  render() {
    if (this.state.data === null || this.props.hide) return null;

    return <div>{ this.renderPanels() }</div>;
  }
}

export default CountryAssistanceOECD;



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistanceOECD.js